'use client';

import React from 'react';
import Onboarding from '$training-portal/modules/onboarding/screen/onboarding/Onboarding';
function page() {
  return <div data-sentry-component="page" data-sentry-source-file="page.tsx">
      <Onboarding data-sentry-element="Onboarding" data-sentry-source-file="page.tsx" />
    </div>;
}
export default page;